module.exports = __webpack_public_path__ + "static/media/me-eyes-looking.8afa82b2.svg";